module.exports = __webpack_public_path__ + "img/icon-gift-colored.f0b92758.svg";